<div class="mx-auto max-w-130 rounded-xl border border-border bg-card p-6 text-fg shadow-md">
  <h1 class="mb-3 text-2xl font-bold">Email not verified</h1>
  <p class="mb-3">Please verify your email before accessing the admin dashboard.</p>
  <p class="mb-3">You can click the link in your email, or resend verification and enter the OTP code below.</p>

  @if (maskedDestination()) {
    <p class="mb-3 text-fg-secondary">Code sent to {{ maskedDestination() }}.</p>
  }

  @if (message()) {
    <ui-alert variant="success">{{ message() }}</ui-alert>
  }
  @if (error()) {
    <ui-alert variant="danger">{{ error() }}</ui-alert>
  }

  <div class="mb-4">
    <button type="button" uiButton variant="outline" (click)="resend()" [disabled]="resending()">
      {{ resending() ? 'Resending...' : 'Resend verification' }}
    </button>
  </div>

  <div class="my-4 flex flex-col gap-3">
    <span class="text-sm font-semibold">OTP code</span>
    <ui-otp-input [(code)]="code" [invalid]="!!error()" [disabled]="loading()" label="Verification code" (completed)="verify()" />
  </div>
  <button type="button" uiButton variant="primary" [block]="true" (click)="verify()" [disabled]="loading() || code.length < 6">
    {{ loading() ? 'Verifying...' : 'Verify email' }}
  </button>
</div>
